export default __webpack_public_path__ + "static/investments-feature-edccc7fb1547c69d6b9827817778b4d2.webp";